import { AxiosInstance } from 'axios';
import { JobDispatchCarrierService } from './services';

type JobAcceptOfferRequest = { jobGuid: string };

export class JobDispatchService {
  instance: AxiosInstance;
  carrier: JobDispatchCarrierService;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.carrier = new JobDispatchCarrierService(instance);
  }

  acceptOffer({ jobGuid }: JobAcceptOfferRequest) {
    return this.instance.put<void>(`/job/${jobGuid}/offers/accept`);
  }

  cancelOffer({ jobGuid }: JobAcceptOfferRequest) {
    return this.instance.put<void>(`/job/${jobGuid}/offers/cancel`);
  }
}
